export const locale = {
    lang: "en",
    data: {
        login: {
            title: "Iniciar sesión en Admin",
            email: {
                label: "Email",
                validation: {
                    required: "Email es un campo obligatorio",
                    emailFormat: "Formato inválido",
                },
            },
            password: {
                label: "Contraseña",
                validation: {
                    required: "Contraseña es un campo obligatorio",
                },
            },
            staySignedId: "Permanecer conectado",
            forgotPassword: "¿Has olvidado tu contraseña ?",
            forgotPasswordTitle: "Recuperar contraseña",
            enterEmailToReset: "Ingresa tu correo para restablecer contraseña",
            send: "Enviar",
            cancel: "Cancelar",
            backToLogin: "Volver al inicio de sesión",
            signInButton: "Ingresar",
            contentTitle: "Bienvenido al Sitio de Industrias JLC",
            contentMessage:
                "Sitio Web de Industrias JLC con más de 65 años ofreciéndote los mejores productos para la limpieza de tu hogar. Conoce nuestra historia, productos y tips.",
            passwordRecoveryConfirmation: {
                message: "La instrucción de recuperación de contraseña ha sido enviada a su correo electrónico.",
            },
            passwordRecoveryError: {
                message: "Error en la petición de recuperación de contraseña.",
            },
            passwordRecoveryCaptchaRequired: {
                message: "Completa la verificación antes de enviar la solicitud.",
            },
            passwordRecoveryCaptchaError: {
                message: "No se pudo validar la verificación. Inténtalo de nuevo.",
            },
            resetPassword: {
                title: "Restablecer contraseña",
                confirmPassword: "Confirmar contraseña",
                submit: "Cambiar contraseña",
                success: "La contraseña se ha actualizado correctamente. Inicia sesión con la nueva contraseña.",
                policy: "La contraseña debe tener al menos {{minLength}} caracteres.",
                validation: {
                    minLength: "La contraseña debe tener al menos {{minLength}} caracteres.",
                    confirmRequired: "Debes confirmar la contraseña.",
                    match: "Las contraseñas no coinciden.",
                },
            },
            resetPasswordError: {
                generic: "No se pudo restablecer la contraseña. Inténtalo de nuevo.",
                invalidToken: "El enlace de recuperación no es válido o ha caducado.",
            },
            signInError: {
                title: "Error al  ingresar",
                genericMessage: "Prueba otra vez más tarde",
                invalidMessage: "Usuario o contraseña no son validos",
            },
        },
    },
};
